export const englishLevels = [
    //"Kickoff", 
    "Pre-k", 
    "Juniors", 
    "Starters", 
    "Movers", 
    "Flyers", 
    "Chat Masters", 
    "World Talkers"
]

export const allEnglishLevels = {
    0:"Kickoff", 
    1:"Pre-k", 
    2:"Juniors", 
    3:"Starters", 
    4:"Movers", 
    5:"Flyers", 
    6:"Chat Masters", 
    7:"World Talkers"
};

export const TRIALS_LEVEL_DESCRIPTION =
    "Trial lessons help determine the right SPEAKID level. Each one includes interactive tasks and clear teacher prompts for every slide, making it an easy, playful way to assess vocabulary, reading, grammar, and speaking skills for beginners.";

/** Trial lesson → program level (0 = Pre-k … 6 = World Talkers). Matches seed order. */
export const TRIAL_LESSON_RECOMMENDED_LEVELS = {
    "alphabet adventure": 0,
    "my pets": 1,
    "a day in the park": 2,
    "let's explore together": 3,
    "my day home, school, and me": 4,
    "let's plan a trip": 5,
    "our planet": 6,
};

export const getTrialRecommendedLevel = (lesson) => {
    const lessonName = lesson?.name?.trim().toLowerCase();
    let levelIndex = lessonName
        ? TRIAL_LESSON_RECOMMENDED_LEVELS[lessonName]
        : undefined;

    if (levelIndex === undefined && Number.isInteger(lesson?.index)) {
        levelIndex = lesson.index;
    }

    if (
        levelIndex === undefined ||
        levelIndex < 0 ||
        levelIndex >= englishLevels.length
    ) {
        return null;
    }

    return {
        index: levelIndex,
        name: englishLevels[levelIndex],
    };
};

export const isTrialsLevel = (levelData) =>
    String(levelData?.level ?? "").toLowerCase() === "trials";

export const getLevelBadgeLabel = (levelData) => {
    if (isTrialsLevel(levelData)) {
        return allEnglishLevels[0];
    }
    return allEnglishLevels[levelData.id] ?? allEnglishLevels[Number(levelData.level) + 1];
};

export const getLevelEmojiSrc = (levelData) =>
    `/emojes/level${isTrialsLevel(levelData) ? "Trials" : levelData.level}.png`;

export const getLevelSummary = (levelData) => {
    if (isTrialsLevel(levelData)) {
        const fromApi = levelData.summary?.trim();
        return fromApi || TRIALS_LEVEL_DESCRIPTION;
    }
    return levelData.summary;
};

export const englishLevelsObject = englishLevels.reduce((obj, level, index) => {
        obj[index] = level;
        return obj;
    }, {});


export const englishLevelsObjectRevers = englishLevels.reduce((obj, level, index) => {
        obj[level] = index;
        return obj;
    }, {});

let englishLevelsObjectArray=[
    {index: "Trials", name: "Trials"},
    {index: 0, name: "Pre-k"},
    {index: 1, name: "Juniors"},
    {index: 2, name: "Starters"},
    {index: 3, name: "Movers"},
    {index: 4, name: "Flyers"},
    {index: 5, name: "Chat Masters"},
    {index: 6, name: "World Talkers"}
]
/* 
englishLevels.map((level, index) => 
    englishLevelsObjectArray = [...englishLevelsObjectArray, {index: index, name: level}]
   );
*/ 
export { englishLevelsObjectArray }
